import React from "react";
import styled from "styled-components";
import { H3, P } from "../components/Typography";

interface Props {}

const Methods: React.FC<Props> = () => {
  return (
    <Background>
      <Section>
        <H3> Unique Aspect 1</H3>
        <P>Lorem Ipsum Dolor</P>
      </Section>
      <Section>
        <H3> Unique Aspect 2</H3>
        <P>Lorem Ipsum Dolor</P>
      </Section>
      <Section>
        <H3> Unique Aspect 3</H3>
        <P>Lorem Ipsum Dolor</P>
      </Section>
    </Background>
  );
};

const Background = styled.div`
  justify-content: space-evenly;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 12px;
`;

const Section = styled.div`
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  padding: 16px 18px;
  flex: 1;
`;

export default Methods;
